import React, { Component } from 'react'
import Link from '~base/router/link'

import api from '~base/api'
import tree from '~core/tree'
import moment from 'moment'

import { AsyncCreatable } from 'react-select'
import 'react-select/dist/react-select.css'

class TagSelect extends Component {
  constructor (props) {
    super(props)
    console.log(this.arrayToValue(props.post[this.props.entity]))
    this.state = {
      open: false,
      value: this.arrayToValue(props.post[this.props.entity])
    }
  }

  async getOptions (input) {
    var url = '/' + this.props.entity + '/search/' + input
    let body = await api.get(url)
    body = body.map(startup => {
      return {value: startup.uuid, label: startup.name}
    })
    return {options: body}
  }

  newOptionCreator (x) {
    return {
      label: x.label,
      value: ''
    }
  }

  arrayToValue (tags) {
    if (tags === undefined) {
      return null
    }

    return tags.map(tag => {
      return {
        value: tag.uuid,
        label: tag.name
      }
    })
  }

  async handleOnChange (value) {
    let payload = {}
    payload[this.props.entity] = value
    var url = '/comparte/posts/tag/' + this.props.post.uuid

    let body = await api.post(url, payload)
    this.props.postUpdate(body.post)
    this.setState({ value: this.arrayToValue(body.post[this.props.entity]) })
  }

  render () {
    if (!this.state.open) {
      return (<a href='javascript:undefined'onClick={() => this.setState({open: true})}> | Tag {this.props.entity}</a>)
    }

    return (<AsyncCreatable name='form-field-name'
      value={this.state.value}
      loadOptions={(i) => this.getOptions(i)}
      newOptionCreator={this.newOptionCreator}
      multi
      onChange={(e) => this.handleOnChange(e)}
    />)
  }
}

class Post extends Component {
  constructor (props) {
    super(props)
    this.state = {
      post: this.props.post,
      vote: this.props.vote
    }
  }

  componentWillMount () {

  }

  postUpdate (post) {
    this.setState({
      post: post
    })
  }

  async vote () {
    var options = {
      postUUID: this.state.post.uuid
    }

    var url = '/comparte/vote'
    const body = await api.post(url, options)
    console.log(body)

    this.setState({
      vote: body.vote,
      post: body.post
    })
  }

  render () {
    var post = this.state.post
    var vote = this.state.vote

    var voteComponent
    if (tree.get('user') && !vote) {
      voteComponent = <div onClick={() => this.vote()}><i className='fa fa-angle-up' /></div>
    }

    let tagSelect
    if (tree.get('user') && tree.get('user').isAdmin) {
      tagSelect = (
        <span>
          <TagSelect entity='startups' post={post} postUpdate={(c) => this.postUpdate(c)} />
          <TagSelect entity='investors' url='' post={post} postUpdate={(c) => this.postUpdate(c)} />
        </span>)
    }

    let startups
    if (post.startups) {
      startups = post.startups.map(startup => <Link to={'/startup/' + startup.slug} className='tag'>{startup.name}</Link>)
    }

    let investors
    if (post.investors) {
      investors = post.investors.map(investor => <Link to={'/investor/' + investor.slug} className='tag'>{investor.name}</Link>)
    }

    return (
      <article className='post columns'>
        <div className='column votes'>
          {voteComponent} {post.voteCount} {(post.voteCount === 1) ? 'punto' : 'puntos'}
        </div>
        <div className='column is-11'>
          <h4>
            <a href={post.url} target='_blank'>{post.title}</a>
            <Link to={'/domain/' + post.hostname} className='hostname'>({post.hostname})</Link>
            {startups}{investors}
          </h4>
          <span className='details'>
            {post.user.name} {moment.utc(post.dateCreated).fromNow()} | <Link to={'/posts/' + post.uuid}> {post.commentCount} comentarios </Link>
            {tagSelect}
          </span>
        </div>

      </article>
    )
  }
}

export default Post



// WEBPACK FOOTER //
// ../frontend/components/post.js